import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid, Typography } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import { fnLocalizeFilter } from "../../../services/localize.service";
import React, { useEffect, useState } from "react";
import { useCustomStyles } from "../../../style/global";
import { useGlobalContext } from "../../../services/context.service";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { accountAPI } from "../../../services/accountAPI.service";

export const useStyles = makeStyles<Theme>( () => ( {
	btnRegister: {
		"&:hover ": {
			color: "#fff",
			cursor: "pointer"
		}
	},
	container: {
		display: "flex",
		position: 'absolute',
		top: 0, left: 0, right: 0, bottom: 0,
		justifyContent: "center",
		alignItems: "center"
	}
} ) );

interface IRegisterDriver {
	otc: string;
	phone: string;
	cardId: string;
}

export default function RegisterDriver ( { basename }: { basename?: string } ) {
	/* Получаем адренсную строку */
	const params = useParams();

	const navigate = useNavigate();

	const classes = useStyles();

	const [ isLoading, setLoading ] = useState( false );

	const [ urlParam, setUrlParam ] = useState<IRegisterDriver | any>( {
		otc: '',
		phone: '',
		cardId: ''
	} );

	const [ updatePhoneOtc ] = accountAPI.useLazyUpdatePhoneOtcQuery();

	const [ showSuccessMessage, setSuccessMessage ] = useState( false );

	useEffect( () => {
		params && setUrlParam( params )
	}, [ params ] )

	const global = useCustomStyles();
	const { locale } = useGlobalContext();

	const handleSubmitRegistrationLink = () => {
		setLoading( true );
		updatePhoneOtc( { locale, otc: urlParam.otc } ).then( res => {
			if ( res && res.data && res.data.errorCode === 0 ) {

				setSuccessMessage( true );
			}
			setLoading( false );
		} );
	};

	const navigateToRegister = () => {
		navigate( `/mode=register&phone=${ urlParam.phone }`, { replace: true } )
	};

	return <>
		<Grid className={ classes.container }>
			<Grid className={ global.textDefault }
			      style={ {
				      maxWidth: "450px",
				      border: "1px solid #ccc",
				      padding: "1rem",
				      borderRadius: "5px"
			      } }>

				{ showSuccessMessage &&
            <>
              <Typography style={ { textAlign: "center" } }>
								{ fnLocalizeFilter( locale, '_lang.module.register.titleRegisterDriverSuccess', [ urlParam.phone, urlParam.cardId ] ) }
              </Typography>
              <Button
                  variant="contained"
                  style={ {
										width: "100%",
										marginTop: "1rem",
										marginRight: "1rem",
										padding: ".7rem 0"
									} }
                  onClick={ navigateToRegister }>
								{ fnLocalizeFilter( locale, '_lang.module.register.btnRegisterOTP' ) }
              </Button>
            </>
				}

				{ !showSuccessMessage &&
            <>
              <Typography style={ { textAlign: "center" } }>
								{ fnLocalizeFilter( locale, '_lang.module.register.titleRegisterDriver', [ urlParam.phone, urlParam.cardId ] ) }
              </Typography>
              <Grid style={ { display: "flex" } }>
                <LoadingButton
                    loading={ isLoading }
                    variant="contained"
                    style={ {
											width: "100%",
											marginTop: "1rem",
											marginRight: "1rem",
											padding: ".7rem 0"
										} }
                    onClick={ handleSubmitRegistrationLink }>
									{ fnLocalizeFilter( locale, '_lang.module.common.title.titleCommit' ) }
                </LoadingButton>
                <Button
                    variant="contained"
                    style={ {
											width: "100%",
											marginTop: "1rem",
											padding: ".7rem 0"
										} }
                    onClick={ () => navigate( '/', { replace: true } ) }>
									{ fnLocalizeFilter( locale, '_lang.module.common.title.titleCancel' ) }
                </Button>
              </Grid>
            </>
				}


			</Grid>
		</Grid>
	</>
}
